import Swal from 'sweetalert2/dist/sweetalert2.js'

const enableSubmitIfCheckboxChecked = () => {
  const checkboxes = document.querySelectorAll('.multi-collapse input[type=checkbox]');
  const btn = document.querySelector(".btn-submit-risk-analysis");
  if (checkboxes) {
    checkboxes.forEach(checkbox => {
      checkbox.addEventListener("change", (event) => {
        if ([...checkboxes].some(box => box.checked)) {
          btn.disabled = false;
        } else {
          btn.disabled = true;
        };
      });
    });
  };
}

const sendAlertWhenInvalid = () => {
  const btn = document.querySelector(".wrapper-btn-submit-risk-analysis");
  if (btn) {
    btn.addEventListener("click", (event) => {
      if (btn.disabled === true) {
        Swal.fire({
          text: "Veuillez cocher des moyens de prévention pour aller à l'étape suivante",
          icon: 'error',
          confirmButtonText: 'Continuer'
        })
      }
    })
  }
}
export { enableSubmitIfCheckboxChecked };
export { sendAlertWhenInvalid };
